module.exports = __webpack_public_path__ + "img/go-ungap-min.f1cfeee3.jpg";